var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"national"},_vm._l((_vm.country),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.goDmky(item)}}},[_c('img',{attrs:{"src":item.dir,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.curnamr))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e43f81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/app/assembly/National.vue
// module id = null
// module chunks = 